import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <FeaturesSection />
        <CommentsSection />
        <MediaSection />
        <CardsSection />
        <AppSection />
        <AboutSection />
        <ContactSection />
        <UpdatesSection />
        <CarouselSection />
        <TopicsSection />
        <FaqSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}